import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of, Subject, BehaviorSubject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { APP_CONFIG } from './../../../configs/app-config.constants';
import { InterfaceAppConfig } from '../../../configs/app-interface.config';

@Injectable({
    providedIn: 'root',
})
export class UserGroupService {
    url: any;
    domainUrl = environment.apiurl;
    gyanDomainUrl = environment.gyanApiUrl;
    constructor(
        private http: HttpClient,
        @Inject(APP_CONFIG)
        private config: InterfaceAppConfig,
    ) {}

    getAccessList(reqBody: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const url = this.gyanDomainUrl + this.config.apis.admin.accessList;
        return this.http.post(url, reqBody, { headers: headers });
    }

    getClientList(req: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const url = this.gyanDomainUrl + this.config.apis.admin.clientList;
        return this.http.post(url, req, { headers: headers });
    }

    createandupdate(req: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const url = this.gyanDomainUrl + this.config.apis.admin.createandUpdate;
        return this.http.post(url, req, { headers: headers });
    }

    displayUsergroupList(req: any): Observable<any> {
        const url = this.gyanDomainUrl + this.config.apis.admin.usergroupList;
        return this.http.post(url, req);
    }

    usergroupType() {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const url = this.gyanDomainUrl + this.config.apis.admin.userGroupType;
        return this.http.get(url);
    }
}
